import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import List from './list';
import Form from './form';

const Component = () => (
  <Switch>
    <Route path="/macs/add"><Form /></Route>
    <Route path="/macs/edit/:id"><Form /></Route>
    <Route path="/macs"><List /></Route>
    <Redirect to="/macs" />
  </Switch>
);

export default Component;
